import React from 'react';
import { HyperdbForm } from '../../../../hyperdb';
import { TextInput, LongTextInput, CodeEditor, Multilingual } from 'hyperdb-utils';

const MultilingualTextInput = Multilingual(TextInput);
const MultilingualCodeEditor = Multilingual(CodeEditor);

class Form extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <fieldset>
        <TextInput
          label="Name"
          name="name"
          value={ this.props.objectData.name }
          onChange={ this.handleChange.bind(this, 'name') }
        />
        <LongTextInput
          label="Parameters"
          name="parameters"
          value={ this.props.objectData.parameters }
          onChange={ this.handleChange.bind(this, 'parameters') }
        />
        <MultilingualTextInput
          label="Page slug"
          name="page_slug"
          value={ this.localizedValue('page_slug') }
          onChange={ this.handleChangeLocalized.bind(this, 'page_slug') }
          availableLocales={ this.props.availableLanguages }
        />
        <MultilingualTextInput
          label="Page title"
          name="page_title"
          value={ this.localizedValue('page_title') }
          onChange={ this.handleChangeLocalized.bind(this, 'page_title') }
          availableLocales={ this.props.availableLanguages }
        />
        <MultilingualTextInput
          label="Meta description"
          name="page_meta_description"
          value={ this.localizedValue('page_meta_description') }
          onChange={ this.handleChangeLocalized.bind(this, 'page_meta_description') }
          availableLocales={ this.props.availableLanguages }
        />
        {/*
          <MultilingualTextInput
            label="Slug"
            name="page_slug"
            value={ this.localizedValue('page_slug') }
            onChange={ this.handleChangeLocalized.bind(this, 'page_slug') }
            availableLocales={ this.props.availableLanguages }
          />
        */}
        <MultilingualTextInput
          label="Presentation title"
          name="presentation_title"
          value={ this.localizedValue('presentation_title') }
          onChange={ this.handleChangeLocalized.bind(this, 'presentation_title') }
          availableLocales={ this.props.availableLanguages }
        />
        <MultilingualCodeEditor
          mode="markdown"
          label="Presentation text"
          name="presentation_text"
          value={ this.localizedValue('presentation_text') }
          onChange={ this.handleChangeLocalized.bind(this, 'presentation_text') }
          availableLocales={ this.props.availableLanguages }
        />
      </fieldset>
    );
  }
  handleChange(attributeName, field) {
    const { name, value } = field;
    this.props.updateEditedObject({ attributeName, value });
  }
  handleChangeLocalized(attributeName, field) {
    const { name, value } = field;
    this.handleChange(attributeName, { value: { $i18n: value } });
  }
  localizedValue(attributeName) {
    return (this.props.objectData[attributeName] || {}).$i18n;
  }
}

Form.propTypes = {
  api: React.PropTypes.object,
  objectData: React.PropTypes.object,
  updateEditedObject: React.PropTypes.func,
  availableLanguages: React.PropTypes.array,
};

export default HyperdbForm(Form, {
  namespace: 'listingContent',
  mountedUrl: '/content/listings',
  titleNew: 'Create new content for listing',
  titleEdit: 'Edit content for listing',
  displayName: (object) => object.name,
});



// WEBPACK FOOTER //
// ./src/frontend/modules/content/listing-content/containers/Form.jsx